import jwtDecode from 'jwt-decode';

interface IRawTokenData {
  'app-claims/company-id': string;
  'app-claims/company-name': string;
  'app-claims/config-id': string;
  'app-claims/tenant-id': string;
  aud: string;
  exp: number;
  'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress': string;
  'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name': string;
  'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier': string;
  iss: string;
  jti: string;
  nbf: number;
}

interface ITokenData {
  configId: number;
  contactId: string;
  name: string;
}

export const decodeAccessToken = (accessToken: string): ITokenData => {
  const rawData: IRawTokenData = jwtDecode(accessToken);

  return {
    configId: +rawData['app-claims/config-id'],
    contactId: rawData['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'],
    name: rawData['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'],
  };
};

/**
 * Checks if a JWT token is valid (not expired)
 * @param token - JWT token string
 * @returns true if token exists and is not expired, false otherwise
 */
export const isTokenValid = (token: string | null): boolean => {
  if (!token) {
    return false;
  }

  try {
    const decoded: IRawTokenData = jwtDecode(token);
    const currentTime = Math.floor(Date.now() / 1000); // Convert to seconds
    
    // Check if token is expired (exp is in seconds)
    // Add a small buffer (60 seconds) to account for clock skew
    return decoded.exp > currentTime + 60;
  } catch (error) {
    // If token cannot be decoded, it's invalid
    return false;
  }
};
